/**
 * Fallback for the pure-CSS scroll compensation.
 *
 * The page CSS uses `scroll-padding-top: var(--nav-offset, 0px)` on the
 * scroll containers (frontend/global.css), so smooth scrolling and the
 * fixed-nav compensation are done by the browser. The page shell sets
 * --nav-offset server-side from the layout's "Scroll-Überhang-Kompensierung"
 * (cms_layout_sets.overlay_offset).
 *
 * This fallback only exists for layouts where that field is empty
 * (--nav-offset == 0): it measures the compiled fixed/sticky nav and sets
 * the same CSS variable, so the CSS keeps doing all the scrolling.
 */

function calculateNavOffset() {
  let nav = document.querySelector("#nav");
  if (document.querySelectorAll(".nav_main_mobile").length > 0) {
    nav = document.querySelector("#nav_main");
  }
  let navOffset = 0;
  if (nav !== null) {
    const navStyle = getComputedStyle(nav);
    if (navStyle.position === 'fixed' || navStyle.position === 'sticky') {
      navOffset = nav.offsetHeight;
    }
  }
  console.debug('[nav-offset] calculated nav offset', {nav, navOffset});
  return navOffset;
}

function refreshNavOffset() {
  const navOffsetValue = getComputedStyle(document.documentElement).getPropertyValue('--nav-offset').trim();
  const navOffset = navOffsetValue.length > 0 ? parseInt(navOffsetValue, 10) : 0;
  if (navOffset === 0) {
    document.documentElement.style.setProperty('--nav-offset', calculateNavOffset() + 'px');
  }
}

function setUpNavOffset() {
  refreshNavOffset();
  // the nav may only become fixed after scrolling past its original position
  // (menu_fixed_scroll), and its height may change with the viewport, so
  // re-measure before every potential anchor jump
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('a[href*="#"]')) {
      refreshNavOffset();
    }
  });
  window.addEventListener('resize', refreshNavOffset);
  window.addEventListener('hashchange', refreshNavOffset);
}

export {setUpNavOffset};
